<template>
    <div>
        <div class="row pattern">
            <section class="notfound" id="notfound">
                <div class="container">
                    <div class="heading-404">
                        <h1>404 Not Found!</h1>
                    </div>
                    <div class="welcomemsg">
                        Something went wrong in your quest for Ember!
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'NotFoundComponent',
        components: { },
        data() {
            return {
                
            }
        },
    }
</script> 